import { useEffect, useState } from "react";
import HomePage from "@/pages/HomePage";
import { useSession } from "@/context/SessionContext";
import { Info } from "lucide-react";

const AGENT_NOTICE_KEY = "invictus_agent_notice_dismissed";

export function AgentInfoBanner() {
  const { t } = useSession();
  return (
    <div data-testid="agent-info-banner" className="relative z-50 bg-brand-blue/10 border-b border-brand-blue/40">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex items-start gap-3">
        <Info size={20} className="text-brand-blue shrink-0 mt-0.5" />
        <p className="text-sm text-slate-300 leading-relaxed">{t("agent.banner")}</p>
      </div>
    </div>
  );
}

// Agenttilstand begrænser kun bestilling — kunder kan stadig se den almindelige forside.
export default function AgentPage() {
  const [showNotice, setShowNotice] = useState(() => sessionStorage.getItem(AGENT_NOTICE_KEY) !== "true");

  useEffect(() => {
    const dismissAfterNavigation = () => {
      if (window.scrollY < 24) return;
      sessionStorage.setItem(AGENT_NOTICE_KEY, "true");
      setShowNotice(false);
    };
    window.addEventListener("scroll", dismissAfterNavigation, { passive: true });
    return () => window.removeEventListener("scroll", dismissAfterNavigation);
  }, []);

  return (
    <div data-testid="agent-page" className="bg-[#0B0E12]">
      {showNotice && <AgentInfoBanner />}
      <HomePage withAgentNotice={showNotice} />
    </div>
  );
}
